export default __webpack_public_path__ + "static/media/doc1.793aba1e.jpg";